// src/config.js
export default {
  partners: [
    {
      name: "Patricia",
      photo: "https://placehold.co/600x600/7650bf/png?text=Patricia+photo",
      expertise: ["More info", "More info"],
      logos: [
        require("@/assets/logo.png"),
        require("@/assets/logo.png"),
        // More logos...
      ],
    },
    {
      name: "Cecilia",
      photo: "https://placehold.co/600x600/7650bf/png?text=Cecilia+photo",
      expertise: ["More info", "More info"],
      logos: [
        require("@/assets/logo.png"),
        require("@/assets/logo.png"),
        // More logos...
      ],
    },
    {
      name: "Avatar 3",
      photo: "https://placehold.co/600x600/7650bf/png?text=Avatar+3+photo",
      expertise: ["More info", "More info"],
      logos: [
        require("@/assets/logo.png"),
        require("@/assets/logo.png"),
        // More logos...
      ],
    },
    // More partners...
  ],
  contactCTA: {
    message: "",
    // Additional contact info...
  },
};
